import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Tab,
  Tabs,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React, { useState } from "react";
import { Router, useNavigate } from "react-router-dom";

import {
  LocalizationProvider,
  DatePicker,
  DateTimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import MainContainer from "../../layout/MainContainer";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function AddUser() {
  const navigate = useNavigate();
  const [isCancellationEnabled, setIsCancellationEnabled] = useState(false);

  const [selectedValue, setSelectedValue] = useState("female");
  const [selectedValue1, setSelectedValue1] = useState("male1");

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const handleChangeNewRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue1(event.target.value);
  };

  const [valueTabs1, setValueTabs1] = React.useState(0);
  const handleChangeTabs2 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs1(newValue);
  };

  const [value, setValue] = React.useState({
    page: "0",
    type: "0",
  });

  const handleChange1 = (event: SelectChangeEvent) => {
    const { name, value } = event.target;
    setValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const goBack = () => {
    navigate(-1); // this goes one step back in history
  };

  const [formvalue, setFormvalue] = React.useState({
    page: "0",
    type: "0",
  });

  const handleChange2 = (event: SelectChangeEvent) => {
    const { name, value } = event.target;
    setFormvalue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const [alignment, setAlignment] = useState("activate");
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(event.target.value);
  };

  const handleChangeToggle = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null
  ) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
    }
  };

  return (
    <>
      <MainContainer>
        <div className="main_title">
          <h1 className="back_arrow">
            {" "}
            <IconButton onClick={() => goBack()}>
              {" "}
              <ArrowBackIcon />{" "}
            </IconButton>{" "}
            User Management
          </h1>
        </div>
        <div className="cards">
          <div className="gap_m avnc_bkng">
            <div className="control_group w_100">
              <label>Type</label>

              <FormControl className="paid_radio">
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="female"
                  name="radio-buttons-group"
                  value={selectedValue}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="female"
                    control={<Radio />}
                    label="Single"
                  />
                  <FormControlLabel
                    value="male"
                    control={<Radio />}
                    label="Duo"
                  />
                </RadioGroup>
              </FormControl>
            </div>

            <div className="control_group w_33">
              <label>Full Name*</label>
              <TextField placeholder="Enter Full Name" hiddenLabel fullWidth />
            </div>

            <div className="control_group w_33">
              <label>Phone Number*</label>
              <TextField
                placeholder="Enter Phone Number"
                hiddenLabel
                fullWidth
              />
            </div>

            <div className="control_group w_33">
              <label>Address</label>
              <TextField placeholder="Enter Address*" hiddenLabel fullWidth />
            </div>

            <div className="control_group w_33">
              <label>Email*</label>
              <TextField placeholder="Enter Email" hiddenLabel fullWidth />
            </div>

            <div className="form_group w_33">
              <label>Field of Expertise</label>
              <Select
                value={formvalue.page}
                name="page"
                onChange={handleChange2}
              >
                <MenuItem value={0} disabled>
                  Select 
                </MenuItem>
                <MenuItem value={10}>Expertise1</MenuItem>
                <MenuItem value={20}>Expertise2</MenuItem>
              </Select>
            </div>

            <div className="w_33 control_group">
              <label>Birthday</label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="form_control"
                  slots={{
                    openPickerIcon: () => (
                      <img src="/static/images/calendar_icon.svg" alt="icon" />
                    ),
                    textField: (params) => (
                      <TextField
                        {...params}
                        fullWidth
                        placeholder="Date"
                        hiddenLabel
                      />
                    ),
                  }}
                  desktopModeMediaQuery="(min-width:0px)"
                />
              </LocalizationProvider>
            </div>

            <div className="form_group w_33">
              <label>Gender</label>
              <Select
                value={formvalue.page}
                name="page"
                onChange={handleChange2}
              >
                <MenuItem value={0} disabled>
                  Select Gender
                </MenuItem>
                <MenuItem value={10}>Male</MenuItem>
                <MenuItem value={20}>Female</MenuItem>
              </Select>
            </div>

            <div className="control_group w_33">
              <label>Dietary Requirements*</label>
              <TextField
                placeholder="Enter Dietary Requirements"
                hiddenLabel
                fullWidth
              />
            </div>

            <div className="control_group w_33">
              <label>Referral Code (Optional)</label>
              <TextField
                placeholder="Enter Referral Code"
                hiddenLabel
                fullWidth
              />
            </div>

            <div className="control_group w_100">
              <label>Interests</label>
              <FormGroup className="text_checkbox">
                <FormControlLabel control={<Checkbox />} label="Dining" />
                <FormControlLabel control={<Checkbox />} label="Events" />
                <FormControlLabel control={<Checkbox />} label="Beach Clubs" />
                <FormControlLabel control={<Checkbox />} label="Night life" />
                <FormControlLabel control={<Checkbox />} label="Travel" />
                <FormControlLabel control={<Checkbox />} label="Experience" />
                <FormControlLabel control={<Checkbox />} label="Ticketing" />

                <FormControlLabel control={<Checkbox />} label="Wellness" />
              </FormGroup>
            </div>

            {selectedValue === "male" && (
              <>
                <div className="control_group w_100">
                  <hr className="m_5" />
                </div>
                <div className="control_group w_100">
                  <h2>Add Secondary/Parnter Detail</h2>
                </div>
                <div className="control_group w_100 ">
                  <label>Do you want fill detail?</label>
                  <div className="archv_ryt">
                    <ToggleButtonGroup
                      color="primary"
                      value={alignment}
                      exclusive
                      onChange={handleChangeToggle}
                      aria-label="Platform"
                    >
                      <ToggleButton value="activate">Yes </ToggleButton>
                      <ToggleButton value="archived">No</ToggleButton>
                    </ToggleButtonGroup>
                  </div>
                </div>
                {alignment === "activate" ? (
                  <>
                    <div className="control_group w_33">
                      <label>Full Name*</label>
                      <TextField
                        placeholder="Enter Full Name"
                        hiddenLabel
                        fullWidth
                      />
                    </div>
                    <div className="control_group w_33">
                      <label>Phone Number*</label>
                      <TextField
                        placeholder="Enter Phone Number"
                        hiddenLabel
                        fullWidth
                      />
                    </div>
                    <div className="control_group w_33">
                      <label>Address</label>
                      <TextField
                        placeholder="Enter Address*"
                        hiddenLabel
                        fullWidth
                      />
                    </div>
                    <div className="control_group w_33">
                      <label>Email*</label>
                      <TextField
                        placeholder="Enter Email"
                        hiddenLabel
                        fullWidth
                      />
                    </div>
                    <div className="control_group w_33">
                      <label>Field of Expertise*</label>
                      <TextField
                        placeholder="Enter Field of Expertise"
                        hiddenLabel
                        fullWidth
                      />
                    </div>
                    <div className="w_33 control_group">
                      <label>Birthday</label>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          className="form_control"
                          slots={{
                            openPickerIcon: () => (
                              <img
                                src="/static/images/calendar_icon.svg"
                                alt="icon"
                              />
                            ),
                            textField: (params) => (
                              <TextField
                                {...params}
                                fullWidth
                                placeholder="Date"
                                hiddenLabel
                              />
                            ),
                          }}
                          desktopModeMediaQuery="(min-width:0px)"
                        />
                      </LocalizationProvider>
                    </div>
                    <div className="form_group w_33">
                      <label>Gender</label>
                      <Select
                        value={formvalue.page}
                        name="page"
                        onChange={handleChange2}
                      >
                        <MenuItem value={0} disabled>
                          Select Gender
                        </MenuItem>
                        <MenuItem value={10}>Male</MenuItem>
                        <MenuItem value={20}>Female</MenuItem>
                      </Select>
                    </div>
                    <div className="control_group w_33">
                      <label>Dietary Requirements*</label>
                      <TextField
                        placeholder="Enter Dietary Requirements"
                        hiddenLabel
                        fullWidth
                      />
                    </div>
                    <div className="control_group w_33">
                      <label>Referral Code (Optional)</label>
                      <TextField
                        placeholder="Enter Referral Code"
                        hiddenLabel
                        fullWidth
                      />
                    </div>
                    <div className="control_group w_100">
                      <label>Interests</label>
                      <FormGroup className="text_checkbox">
                        <FormControlLabel
                          control={<Checkbox />}
                          label="Dining"
                        />
                        <FormControlLabel
                          control={<Checkbox />}
                          label="Events"
                        />
                        <FormControlLabel
                          control={<Checkbox />}
                          label="Beach Clubs"
                        />
                        <FormControlLabel
                          control={<Checkbox />}
                          label="Night life"
                        />
                        <FormControlLabel
                          control={<Checkbox />}
                          label="Travel"
                        />
                        <FormControlLabel
                          control={<Checkbox />}
                          label="Experience"
                        />
                        <FormControlLabel
                          control={<Checkbox />}
                          label="Ticketing"
                        />

                        <FormControlLabel
                          control={<Checkbox />}
                          label="Wellness"
                        />
                      </FormGroup>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="control_group w_33">
                      <label> Secondary/Parnter Email</label>
                      <TextField
                        placeholder="Enter Email"
                        hiddenLabel
                        fullWidth
                      />
                    </div>
                    <div className="control_group w_100">
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox defaultChecked />}
                          label="Send Inventation"
                        />
                      </FormGroup>
                    </div>
                  </>
                )}

            

             
              </>
            )}

    <div className="control_group w_100">
                  <label>Type</label>

                  <FormControl className="paid_radio select_payer">
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue="female"
                      name="radio-buttons-group"
                      value={selectedValue1}
                      onChange={handleChangeNewRadio}
                    >
                      <FormControlLabel
                        value="female1"
                        control={<Radio />}
                        label="Free Trial"
                      />
                      <FormControlLabel
                        value="male1"
                        control={<Radio />}
                        label="Complementary"
                      />

                      <FormControlLabel
                        value="paid"
                        control={<Radio />}
                        label="Paid"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>

                   {selectedValue1 === "paid" ? (
                  <div className="form_group w_33">
                    <label>Select Payer</label>
                    <Select
                      value={formvalue.page}
                      name="page"
                      onChange={handleChange2}
                    >
                      <MenuItem value={0} disabled>
                        Primary Member
                      </MenuItem>
                      <MenuItem value={10}>Primary Member</MenuItem>
                      <MenuItem value={20}>Secondary Member</MenuItem>
                      <MenuItem value={30}>Split</MenuItem>
                    </Select>
                  </div>
                ) : (
                  <div className="w_33 control_group">
                    <label>Date</label>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        className="form_control"
                        slots={{
                          openPickerIcon: () => (
                            <img
                              src="/static/images/calendar_icon.svg"
                              alt="icon"
                            />
                          ),
                          textField: (params) => (
                            <TextField
                              {...params}
                              fullWidth
                              placeholder="Date"
                              hiddenLabel
                            />
                          ),
                        }}
                        desktopModeMediaQuery="(min-width:0px)"
                      />
                    </LocalizationProvider>
                  </div>
                )}

          </div>
          <div className="btn_flex mt_30">
            <Button
              className="btn btn_primary"
              onClick={() => navigate("/manage-customers")}
            >
              Save
            </Button>
          </div>
        </div>
      </MainContainer>
    </>
  );
}

export default AddUser;
